import CasinoTV from "../../components/CasinoTV.jsx";
import React, { useEffect } from "react";
import {
  getCasinoExposureAPI,
  getUniversalCasinoLastResultAPI,
  getUniversalCasinoOddsAPI,
  uniCasinoBetAPI,
} from "../../service/casino/index.js";
import { useLocation, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import {
  getUniversalCasinoPlExposureByRunner,
  GetUniversalLastTenResult,
  UNIVERSAL_EXTRA_CARDS,
} from "./genericFunctions.jsx";
import PlaceBetUniversal from "./PlaceBetUniversal.jsx";
import GenericCasinoTimer from "../../components/GenericCasinoTimer.jsx";

export default function BollywoodCasino() {
  const GAME_ID = "UNI_BOLLYWOOD_CASINO";
  const haveModule2 = GAME_ID?.includes("LUCKY_7_A");
  const haveCardSuit = GAME_ID?.includes("LUCKY_7_A");
  const [odds, setOdds] = React.useState({});
  const [lastResult, setLastResult] = React.useState({});
  const [exposure, setExposure] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [timer, setTimer] = React.useState(0);
  const [placeBetPayload, setPlaceBetPayload] = React.useState({
    amount: 0,
    back: 0,
    casinoGames: GAME_ID,
    marketId: "",
    runnerName: "",
    marketIdWithSelectionId: "",
    type: "back",
  });
  const roundIdRef = React.useRef();
  const getOdds = async () => {
    const { response } = await getUniversalCasinoOddsAPI(GAME_ID);
    setOdds(response);
  };
  const getLastResult = async () => {
    const { response } = await getUniversalCasinoLastResultAPI(GAME_ID);
    setLastResult(response);
  };
  const getExposure = async () => {
    const { response } = await getCasinoExposureAPI(roundIdRef.current);
    setExposure(response);
  };
  useEffect(() => {
    roundIdRef.current = odds?.roundId;
    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [odds?.roundId]);
  const placeBet = async (
    marketIdWithSelectionId,
    runnerName,
    back,
    isBack = true
  ) => {
    let payload = { ...placeBetPayload };
    payload.marketIdWithSelectionId = `${marketIdWithSelectionId}`;
    payload.runnerName = runnerName;
    payload.back = back;
    if (!isBack) {
      payload.lay = back;
      delete payload["back"];
    }

    payload.marketId = odds?.roundId;
    payload.amount = 100;
    payload.type = isBack ? "back" : "lay";
    payload.casinoGames = GAME_ID;
    setPlaceBetPayload(payload);
  };
  const placeBetCallApi = async () => {
    setLoading(true);
    const { response, code, status } = await uniCasinoBetAPI(placeBetPayload);
    if (code === 200) {
      toast.success(status);
      getOdds();
      setPlaceBetPayload(null);
    } else {
      toast.error(response);
    }
    setLoading(false);
  };
  React.useEffect(() => {
    getOdds();
    getLastResult();
    let interval = setInterval(() => {
      getOdds();
    }, 800);
    let interval2 = setInterval(() => {
      getLastResult();
    }, 5000);
    let interval3 = setInterval(() => {
      getExposure();
    }, 2000);
    return () => {
      clearInterval(interval);
      clearInterval(interval2);
      clearInterval(interval3);
    };
  }, []);
  const [showWinnerOverlay, setShowWinnerOverlay] = React.useState(false);

  // Function to check time condition
  const checkTimeCondition = () => {
    const timeA = new Date().getTime();
    const roundWinnerUpdatedAt = odds?.roundWinnerUpdatedAt;
    if (timeA < roundWinnerUpdatedAt + 3000 && timeA >= roundWinnerUpdatedAt) {
      setShowWinnerOverlay(true);
    } else {
      setShowWinnerOverlay(false);
    }
  };
  useEffect(() => {
    roundIdRef.current = odds?.roundId;

    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);
    let timeCheckInterval = setInterval(checkTimeCondition, 100);

    return () => {
      clearInterval(interval);
      clearInterval(timeCheckInterval);
    };
  }, [odds?.roundId, odds?.roundWinnerUpdatedAt]);
  const ALPHA_CARDS = ["A", "B", "C", "D", "E", "F"];
  return (
    <div s>
      <app-casino-room _ngcontent-ng-c663229740="" _nghost-ng-c2733776549="">
        <div
          _ngcontent-ng-c2733776549=""
          _ngcontent-ysg-c0=""
          id="playerInfo"
          className="top"
        >
          <div
            _ngcontent-ng-c2733776549=""
            _ngcontent-ysg-c0=""
            className="left_list"
          />
          <div
            _ngcontent-ng-c2733776549=""
            _ngcontent-ysg-c0=""
            className="right_list none-lobby-page hasTimer"
          >
            <ol _ngcontent-ng-c2733776549="" _ngcontent-ysg-c0="">
              <li _ngcontent-ng-c2733776549="" style={{ cursor: "pointer" }}>
                <i
                  _ngcontent-ng-c2733776549=""
                  _ngcontent-cuc-c0=""
                  className="fa fa-cog fa-lg"
                />
              </li>
            </ol>
          </div>
        </div>
        <div
          _ngcontent-ng-c2733776549=""
          id="stackbetsModal"
          aria-labelledby="stackbetsModal"
          aria-hidden="true"
          className="modal fade"
        >
          <div _ngcontent-ng-c2733776549="" className="modal-dialog">
            <div _ngcontent-ng-c2733776549="" className="modal-content">
              <div _ngcontent-ng-c2733776549="" className="modal-header">
                <h3 _ngcontent-ng-c2733776549="" className="mb-0 bold">
                  Stake
                </h3>
              </div>
              <div _ngcontent-ng-c2733776549="" className="stack-modal-body">
                <div
                  _ngcontent-ng-c2733776549=""
                  className="card-body container-fluid container-fluid-5 button-value quick-stake-container"
                >
                  <div
                    _ngcontent-ng-c2733776549=""
                    className="row row5 mb-1 desktop-pl"
                  >
                    <div _ngcontent-ng-c2733776549="" className="col-3">
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="button-title"
                        style={{ fontSize: 14, marginLeft: "-2px" }}
                      >
                        <span _ngcontent-ng-c2733776549="">
                          <b
                            _ngcontent-ng-c2733776549=""
                            className="stake-amount"
                          >
                            Quick Stakes
                          </b>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    _ngcontent-ng-c2733776549=""
                    className="row row5 mb-1 col-md-12 desktop-pl quick-stake-boxes"
                  >
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks0"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks1"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks2"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks3"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks4"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks5"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks6"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks7"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div _ngcontent-ng-c2733776549="" className="modal-footer">
                  <button _ngcontent-ng-c2733776549="" className="updatebtn">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </app-casino-room>
      <router-outlet _ngcontent-ng-c663229740="" />
      <app-teenpatti _nghost-ng-c2991413133="">
        <div _ngcontent-ng-c2991413133="" style={{ overflowY: "hidden" }}>
          <div _ngcontent-ng-c2991413133="">
            <app-video-player
              _ngcontent-ng-c2991413133=""
              _nghost-ng-c595356512=""
            >
              <div _ngcontent-ng-c595356512="" className="videoPlayer">
                <CasinoTV casinoGames={GAME_ID} />

                <div _ngcontent-ng-c595356512="" className="video-overlay">
                  <div _ngcontent-ng-c595356512="">
                    <div
                      _ngcontent-ng-c595356512=""
                      className="round-id text-white"
                    >
                      RID: {odds?.roundId}
                    </div>

                    {odds?.playerCards?.map((player) => (
                      <div _ngcontent-ng-c595356512="">
                        <h3 _ngcontent-ng-c595356512="" className="text-white">
                          {player?.forPerson}
                        </h3>
                        <div _ngcontent-ng-c595356512="">
                          {player?.cards?.map((card) => (
                            <img
                              _ngcontent-ng-c595356512=""
                              src={`https://casino.queenexch.com/assets/cards/${card?.cardValue}.png`}
                            />
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {showWinnerOverlay && (
                  <div _ngcontent-ng-c595356512="" className="winnerOverlay">
                    <div
                      _ngcontent-ng-c595356512=""
                      className="mini-result-new active"
                    >
                      <span _ngcontent-ng-c595356512="">
                        {" "}
                        {odds?.roundWinner} win{" "}
                      </span>
                      {/**/}
                    </div>
                    <span
                      _ngcontent-ng-c595356512=""
                      style={{ position: "absolute" }}
                    >
                      <canvas
                        _ngcontent-ng-c595356512=""
                        width="100vw"
                        height="100vh"
                      />
                    </span>
                    {/**/}
                  </div>
                )}

                <div _ngcontent-ng-c595356512="" className="timer-overlay">
                  <GenericCasinoTimer
                    time={odds?.seconds}
                    status={odds?.status}
                  />
                </div>
              </div>

              <div
                _ngcontent-ng-c595356512=""
                id="rulesModal"
                tabIndex={-1}
                aria-labelledby="exampleModalLabelaexampleModalLabela"
                aria-hidden="true"
                className="modal fade"
              >
                <div
                  _ngcontent-ng-c595356512=""
                  className="modal-dialog rules-wrap"
                >
                  <div
                    _ngcontent-ng-c595356512=""
                    role="document"
                    id="rulesList___BV_modal_content_"
                    tabIndex={-1}
                    className="modal-content rules-content"
                  >
                    <header
                      _ngcontent-ng-c595356512=""
                      id="rulesList___BV_modal_header_"
                      className="rules-wrap"
                    >
                      <a _ngcontent-ng-c595356512="">
                        <h3
                          _ngcontent-ng-c595356512=""
                          id="rulesList___BV_modal_title_"
                          data-bs-toggle="modal"
                          data-bs-target="#rulesModal"
                          className="modal-title"
                        >
                          Rules
                        </h3>
                      </a>
                      <button
                        _ngcontent-ng-c595356512=""
                        type="button"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        className="close"
                      >
                        ×
                      </button>
                    </header>
                    <div
                      _ngcontent-ng-c595356512=""
                      id="rulesList___BV_modal_body_"
                      className="modal-body"
                    >
                      <div _ngcontent-ng-c595356512="" id="rulesBoxContainer" />
                    </div>
                    <div _ngcontent-ng-c595356512="">
                      <ul
                        _ngcontent-ng-c595356512=""
                        className="btn-wrap break"
                      >
                        <li _ngcontent-ng-c595356512="">
                          <a
                            _ngcontent-ng-c595356512=""
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            className="btnok"
                          >
                            OK
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </app-video-player>
          </div>
          <div
            _ngcontent-ng-c2501606979=""
            id="marketScroll"
            style={{ overflowY: "auto" }}
            className="overflow-auto"
          >
            <div _ngcontent-ng-c2501606979="" className="card">
              <span
                _ngcontent-ng-c2501606979=""
                className="btn btn-primary card-header inner-sportbook"
              >
                <span
                  _ngcontent-ng-c2501606979=""
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="true"
                  aria-controls="multiCollapseExample1"
                  className="minmax"
                  data-bs-target="#multiCollapseExample9501903112738"
                >
                  <strong _ngcontent-ng-c2501606979="">WINNER</strong>
                </span>
                <div _ngcontent-ng-c2501606979="" className="minMaxDesktop">
                  <span _ngcontent-ng-c2501606979="">
                    Min/Max: 100 - 500000{" "}
                  </span>
                </div>
                <span _ngcontent-ng-c2501606979="" className="minMaxMobile">
                  <i
                    _ngcontent-ng-c2501606979=""
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    className="fa fa-info-circle ml-2"
                    data-bs-target="#multiCollapseExample9501903112738"
                    id="#collapse129501903112738"
                  />
                  <ul
                    _ngcontent-ng-c2501606979=""
                    className="dropdown-menu icon-range min-max-info text-end tooltip-betlimit"
                    aria-labelledby="collapse129501903112738"
                  >
                    <span _ngcontent-ng-c2501606979="">
                      Min/Max: 100 - 500000{" "}
                    </span>
                  </ul>
                </span>
              </span>
              <div _ngcontent-ng-c2501606979="" className="col">
                <div
                  _ngcontent-ng-c2501606979=""
                  className="collapse multi-collapse show"
                  id="multiCollapseExample9501903112738"
                >
                  <div
                    _ngcontent-ng-c2501606979=""
                    className="tbl-bets p-rltv sportbook-market-tbl"
                  >
                    {odds?.status == "SUSPEND" && (
                      <div
                        _ngcontent-ng-c2501606979=""
                        class="suspended-casino"
                      >
                        <span _ngcontent-ng-c2501606979="" class="stats-text">
                          Suspended
                        </span>
                      </div>
                    )}
                    {odds?.markets
                      ?.find((market) => market?.marketName === "WINNER")
                      ?.oddDetailsDTO?.map((market, index) => (
                        <>
                          <div
                            _ngcontent-ng-c2501606979=""
                            className="odd-row playerABgTie"
                          >
                            <div
                              _ngcontent-ng-c2501606979=""
                              className="col ps-0 pe-0 boxPlayer"
                            >
                              <div
                                _ngcontent-ng-c2501606979=""
                                className="d-flex justify-content-center align-content-center flex-column"
                              >
                                <span
                                  _ngcontent-ng-c2501606979=""
                                  style={{
                                    position: "absolute",
                                    zIndex: 1,
                                    fontSize: "small",
                                  }}
                                >
                                  <img
                                    _ngcontent-ng-c2501606979=""
                                    src={`https://casino.queenexch.com/assets/bollywood/${ALPHA_CARDS[index]}-01.svg`}
                                    className="A-svg"
                                  />

                                  {market?.runnerName}
                                  {getUniversalCasinoPlExposureByRunner(
                                    exposure,
                                    market?.runnerName,
                                    market?.selectionId
                                  )}
                                </span>
                                <div
                                  _ngcontent-ng-c2501606979=""
                                  className="d-flex align-items-center p-0"
                                ></div>
                              </div>
                              <div
                                _ngcontent-ng-c2501606979=""
                                className="d-flex"
                              >
                                <div
                                  _ngcontent-ng-c2501606979=""
                                  appratehighlight=""
                                  onClick={() =>
                                    placeBet(
                                      `${
                                        odds?.markets?.find(
                                          (market) =>
                                            market?.marketName === "WINNER"
                                        )?.marketId
                                      }_${market?.selectionId}`,
                                      market?.runnerName,
                                      market?.back1
                                    )
                                  }
                                  className="marginRight5 back-1 oddsBox sportbook-minwidth p-rltv"
                                >
                                  <a
                                    _ngcontent-ng-c2501606979=""
                                    className="d-flex flex-column p-0 align-items-center"
                                    style={{
                                      textDecoration: "none",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {market?.back1}
                                    <span
                                      _ngcontent-ng-c2501606979=""
                                      className="d-flex justify-content-center"
                                      style={{ fontSize: 11, fontWeight: 400 }}
                                    >
                                      {market?.backSize1}
                                    </span>
                                  </a>
                                </div>
                                <div
                                  _ngcontent-ng-c2501606979=""
                                  appratehighlight=""
                                  onClick={() =>
                                    placeBet(
                                      `${
                                        odds?.markets?.find(
                                          (market) =>
                                            market?.marketName === "WINNER"
                                        )?.marketId
                                      }_${market?.selectionId}`,
                                      market?.runnerName,
                                      market?.lay1,
                                      false
                                    )
                                  }
                                  className="lay-1 oddsBox sportbook-minwidth p-rltv"
                                >
                                  <a
                                    _ngcontent-ng-c2501606979=""
                                    className="d-flex flex-column p-0 align-items-center"
                                    style={{
                                      textDecoration: "none",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {market?.lay1}
                                    <span
                                      _ngcontent-ng-c2501606979=""
                                      className="d-flex justify-content-center"
                                      style={{ fontSize: 11, fontWeight: 400 }}
                                    >
                                      {market?.laySize1}
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          {placeBetPayload?.marketIdWithSelectionId ==
                            `${
                              odds?.markets?.find(
                                (market) => market?.marketName === "WINNER"
                              )?.marketId
                            }_${market?.selectionId}` && (
                            <PlaceBetUniversal
                              placeBetPayload={placeBetPayload}
                              setPlaceBetPayload={setPlaceBetPayload}
                              placeBet={placeBetCallApi}
                            />
                          )}
                        </>
                      ))}
                  </div>
                </div>
              </div>
            </div>
            <div _ngcontent-ng-c2501606979="" className="card">
              <span
                _ngcontent-ng-c2501606979=""
                className="btn btn-primary card-header inner-sportbook"
              >
                <span
                  _ngcontent-ng-c2501606979=""
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="true"
                  aria-controls="multiCollapseExample1"
                  className="minmax"
                  data-bs-target="#multiCollapseExample9501903112739"
                >
                  <strong _ngcontent-ng-c2501606979="">ODD</strong>
                </span>
                <div _ngcontent-ng-c2501606979="" className="minMaxDesktop">
                  <span _ngcontent-ng-c2501606979="">
                    Min/Max: 100 - 500000{" "}
                  </span>
                </div>
                <span _ngcontent-ng-c2501606979="" className="minMaxMobile">
                  <i
                    _ngcontent-ng-c2501606979=""
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    className="fa fa-info-circle ml-2"
                    data-bs-target="#multiCollapseExample9501903112739"
                    id="#collapse129501903112739"
                  />
                  <ul
                    _ngcontent-ng-c2501606979=""
                    className="dropdown-menu icon-range min-max-info text-end tooltip-betlimit"
                    aria-labelledby="collapse129501903112739"
                  >
                    <span _ngcontent-ng-c2501606979="">
                      Min/Max: 100 - 500000{" "}
                    </span>
                  </ul>
                </span>
              </span>
              <div _ngcontent-ng-c2501606979="" className="col">
                <div
                  _ngcontent-ng-c2501606979=""
                  className="collapse multi-collapse show"
                  id="multiCollapseExample9501903112739"
                >
                  <div
                    _ngcontent-ng-c2501606979=""
                    className="tbl-bets p-rltv sportbook-market-tbl"
                  >
                    {odds?.status == "SUSPEND" && (
                      <div
                        _ngcontent-ng-c2501606979=""
                        class="suspended-casino"
                      >
                        <span _ngcontent-ng-c2501606979="" class="stats-text">
                          Suspended
                        </span>
                      </div>
                    )}
                    {odds?.markets
                      ?.find((market) => market?.marketName === "ODD")
                      ?.oddDetailsDTO?.map((market, index) => (
                        <>
                          <div
                            _ngcontent-ng-c2501606979=""
                            className="odd-row playerABgTie"
                          >
                            <div
                              _ngcontent-ng-c2501606979=""
                              className="col ps-0 pe-0 boxPlayer"
                            >
                              <div
                                _ngcontent-ng-c2501606979=""
                                className="d-flex justify-content-center align-content-center flex-column"
                              >
                                <span
                                  _ngcontent-ng-c2501606979=""
                                  style={{
                                    position: "absolute",
                                    zIndex: 1,
                                    fontSize: "small",
                                  }}
                                >
                                  {market?.runnerName}
                                  {getUniversalCasinoPlExposureByRunner(
                                    exposure,
                                    market?.runnerName,
                                    market?.selectionId
                                  )}
                                </span>
                                <div
                                  _ngcontent-ng-c2501606979=""
                                  className="d-flex align-items-center p-0"
                                ></div>
                              </div>
                              <div
                                _ngcontent-ng-c2501606979=""
                                className="d-flex"
                              >
                                <div
                                  _ngcontent-ng-c2501606979=""
                                  appratehighlight=""
                                  onClick={() =>
                                    placeBet(
                                      `${
                                        odds?.markets?.find(
                                          (market) =>
                                            market?.marketName === "ODD"
                                        )?.marketId
                                      }_${market?.selectionId}`,
                                      market?.runnerName,
                                      market?.back1
                                    )
                                  }
                                  className="marginRight5 back-1 oddsBox sportbook-minwidth p-rltv"
                                >
                                  <a
                                    _ngcontent-ng-c2501606979=""
                                    className="d-flex flex-column p-0 align-items-center"
                                    style={{
                                      textDecoration: "none",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {market?.back1}
                                    <span
                                      _ngcontent-ng-c2501606979=""
                                      className="d-flex justify-content-center"
                                      style={{ fontSize: 11, fontWeight: 400 }}
                                    >
                                      {market?.backSize1}
                                    </span>
                                  </a>
                                </div>
                                <div
                                  _ngcontent-ng-c2501606979=""
                                  appratehighlight=""
                                  onClick={() =>
                                    placeBet(
                                      `${
                                        odds?.markets?.find(
                                          (market) =>
                                            market?.marketName === "ODD"
                                        )?.marketId
                                      }_${market?.selectionId}`,
                                      market?.runnerName,
                                      market?.lay1,
                                      false
                                    )
                                  }
                                  className="lay-1 oddsBox sportbook-minwidth p-rltv"
                                >
                                  <a
                                    _ngcontent-ng-c2501606979=""
                                    className="d-flex flex-column p-0 align-items-center"
                                    style={{
                                      textDecoration: "none",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {market?.lay1}
                                    <span
                                      _ngcontent-ng-c2501606979=""
                                      className="d-flex justify-content-center"
                                      style={{ fontSize: 11, fontWeight: 400 }}
                                    >
                                      {market?.laySize1}
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          {placeBetPayload?.marketIdWithSelectionId ==
                            `${
                              odds?.markets?.find(
                                (market) => market?.marketName === "ODD"
                              )?.marketId
                            }_${market?.selectionId}` && (
                            <PlaceBetUniversal
                              placeBetPayload={placeBetPayload}
                              setPlaceBetPayload={setPlaceBetPayload}
                              placeBet={placeBetCallApi}
                            />
                          )}
                        </>
                      ))}
                  </div>
                </div>
              </div>
            </div>
            <div _ngcontent-ng-c2501606979="" className="card">
              <span
                _ngcontent-ng-c2501606979=""
                className="btn btn-primary card-header inner-sportbook"
              >
                <span
                  _ngcontent-ng-c2501606979=""
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="true"
                  aria-controls="multiCollapseExample1"
                  className="minmax"
                  data-bs-target="#multiCollapseExample9501903112740"
                >
                  <strong _ngcontent-ng-c2501606979="">
                    DULHA DULHAN/BARATI
                  </strong>
                </span>
                <div _ngcontent-ng-c2501606979="" className="minMaxDesktop">
                  <span _ngcontent-ng-c2501606979="">
                    Min/Max: 100 - 500000{" "}
                  </span>
                </div>
                <span _ngcontent-ng-c2501606979="" className="minMaxMobile">
                  <i
                    _ngcontent-ng-c2501606979=""
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    className="fa fa-info-circle ml-2"
                    data-bs-target="#multiCollapseExample9501903112740"
                    id="#collapse129501903112740"
                  />
                  <ul
                    _ngcontent-ng-c2501606979=""
                    className="dropdown-menu icon-range min-max-info text-end tooltip-betlimit"
                    aria-labelledby="collapse129501903112740"
                  >
                    <span _ngcontent-ng-c2501606979="">
                      Min/Max: 100 - 500000{" "}
                    </span>
                  </ul>
                </span>
              </span>
              <div _ngcontent-ng-c2501606979="" className="col">
                <div
                  _ngcontent-ng-c2501606979=""
                  className="collapse multi-collapse show"
                  id="multiCollapseExample9501903112740"
                >
                  <div
                    _ngcontent-ng-c2501606979=""
                    className="tbl-bets p-rltv sportbook-market-tbl"
                  >
                    {odds?.status == "SUSPEND" && (
                      <div
                        _ngcontent-ng-c2501606979=""
                        class="suspended-casino"
                      >
                        <span _ngcontent-ng-c2501606979="" class="stats-text">
                          Suspended
                        </span>
                      </div>
                    )}
                    {odds?.markets
                      ?.find(
                        (market) => market?.marketName === "DULHA DULHAN/BARATI"
                      )
                      ?.oddDetailsDTO?.map((market, index) => (
                        <>
                          <div
                            _ngcontent-ng-c2501606979=""
                            className="odd-row playerABgTie"
                          >
                            <div
                              _ngcontent-ng-c2501606979=""
                              className="col ps-0 pe-0 boxPlayer"
                            >
                              <div
                                _ngcontent-ng-c2501606979=""
                                className="d-flex justify-content-center align-content-center flex-column"
                              >
                                <span
                                  _ngcontent-ng-c2501606979=""
                                  style={{
                                    position: "absolute",
                                    zIndex: 1,
                                    fontSize: "small",
                                  }}
                                >
                                  {market?.runnerName}
                                  {getUniversalCasinoPlExposureByRunner(
                                    exposure,
                                    market?.runnerName,
                                    market?.selectionId
                                  )}
                                </span>
                                <div
                                  _ngcontent-ng-c2501606979=""
                                  className="d-flex align-items-center p-0"
                                ></div>
                              </div>
                              <div
                                _ngcontent-ng-c2501606979=""
                                className="d-flex"
                              >
                                <div
                                  _ngcontent-ng-c2501606979=""
                                  appratehighlight=""
                                  onClick={() =>
                                    placeBet(
                                      `${
                                        odds?.markets?.find(
                                          (market) =>
                                            market?.marketName ===
                                            "DULHA DULHAN/BARATI"
                                        )?.marketId
                                      }_${market?.selectionId}`,
                                      market?.runnerName,
                                      market?.back1
                                    )
                                  }
                                  className="marginRight5 back-1 oddsBox sportbook-minwidth p-rltv"
                                >
                                  <a
                                    _ngcontent-ng-c2501606979=""
                                    className="d-flex flex-column p-0 align-items-center"
                                    style={{
                                      textDecoration: "none",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {market?.back1}
                                    <span
                                      _ngcontent-ng-c2501606979=""
                                      className="d-flex justify-content-center"
                                      style={{ fontSize: 11, fontWeight: 400 }}
                                    >
                                      {market?.backSize1}
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          {placeBetPayload?.marketIdWithSelectionId ==
                            `${
                              odds?.markets?.find(
                                (market) =>
                                  market?.marketName === "DULHA DULHAN/BARATI"
                              )?.marketId
                            }_${market?.selectionId}` && (
                            <PlaceBetUniversal
                              placeBetPayload={placeBetPayload}
                              setPlaceBetPayload={setPlaceBetPayload}
                              placeBet={placeBetCallApi}
                            />
                          )}
                        </>
                      ))}
                  </div>
                </div>
              </div>
            </div>
            <div _ngcontent-ng-c2501606979="" className="card">
              <span
                _ngcontent-ng-c2501606979=""
                className="btn btn-primary card-header inner-sportbook"
              >
                <span
                  _ngcontent-ng-c2501606979=""
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="true"
                  aria-controls="multiCollapseExample1"
                  className="minmax"
                  data-bs-target="#multiCollapseExample9501903112741"
                >
                  <strong _ngcontent-ng-c2501606979="">COLOR</strong>
                </span>
                <div _ngcontent-ng-c2501606979="" className="minMaxDesktop">
                  <span _ngcontent-ng-c2501606979="">
                    Min/Max: 100 - 500000{" "}
                  </span>
                </div>
                <span _ngcontent-ng-c2501606979="" className="minMaxMobile">
                  <i
                    _ngcontent-ng-c2501606979=""
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    className="fa fa-info-circle ml-2"
                    data-bs-target="#multiCollapseExample9501903112741"
                    id="#collapse129501903112741"
                  />
                  <ul
                    _ngcontent-ng-c2501606979=""
                    className="dropdown-menu icon-range min-max-info text-end tooltip-betlimit"
                    aria-labelledby="collapse129501903112741"
                  >
                    <span _ngcontent-ng-c2501606979="">
                      Min/Max: 100 - 500000{" "}
                    </span>
                  </ul>
                </span>
              </span>
              <div _ngcontent-ng-c2501606979="" className="col">
                <div
                  _ngcontent-ng-c2501606979=""
                  className="collapse multi-collapse show"
                  id="multiCollapseExample9501903112741"
                >
                  <div
                    _ngcontent-ng-c2501606979=""
                    className="tbl-bets p-rltv sportbook-market-tbl"
                  >
                    <div
                      _ngcontent-ng-c2501606979=""
                      className="text-center cardMarket"
                    >
                      {odds?.status == "SUSPEND" && (
                        <div
                          _ngcontent-ng-c2501606979=""
                          class="suspended-casino"
                        >
                          <span _ngcontent-ng-c2501606979="" class="stats-text">
                            Suspended
                          </span>
                        </div>
                      )}
                      {odds?.markets
                        ?.find((market) => market?.marketName === "COLOR")
                        ?.oddDetailsDTO?.map((market, index) => (
                          <>
                            <div
                              _ngcontent-ng-c2501606979=""
                              className="box-2 back backboxonly boxmarket"
                            >
                              <div
                                onClick={() =>
                                  placeBet(
                                    `${
                                      odds?.markets?.find(
                                        (market) =>
                                          market?.marketName === "COLOR"
                                      )?.marketId
                                    }_${market?.selectionId}`,
                                    market?.runnerName,
                                    market?.back1
                                  )
                                }
                                _ngcontent-ng-c2501606979=""
                                className="me-2 dt-card d-inline-block"
                              >
                                <div
                                  _ngcontent-ng-c2501606979=""
                                  className="casino-font h38"
                                >
                                  {market?.runnerName}
                                  {getUniversalCasinoPlExposureByRunner(
                                    exposure,
                                    market?.runnerName,
                                    market?.selectionId
                                  )}
                                </div>
                                <div
                                  _ngcontent-ng-c2501606979=""
                                  className="ubook text-center m-t-5 text-success h-18"
                                >
                                  <span
                                    _ngcontent-ng-c2501606979=""
                                    className="mb-0 h18 d-flex justify-content-center align-items-center"
                                    style={{ color: "black" }}
                                  ></span>
                                </div>
                              </div>
                            </div>
                          </>
                        ))}
                    </div>
                    {odds?.markets
                      ?.find((market) => market?.marketName === "COLOR")
                      ?.oddDetailsDTO?.map(
                        (market, index) =>
                          placeBetPayload?.marketIdWithSelectionId ==
                            `${
                              odds?.markets?.find(
                                (market) => market?.marketName === "COLOR"
                              )?.marketId
                            }_${market?.selectionId}` && (
                            <PlaceBetUniversal
                              placeBetPayload={placeBetPayload}
                              setPlaceBetPayload={setPlaceBetPayload}
                              placeBet={placeBetCallApi}
                            />
                          )
                      )}
                  </div>
                </div>
              </div>
            </div>
            <div _ngcontent-ng-c2501606979="" className="card">
              <span
                _ngcontent-ng-c2501606979=""
                className="btn btn-primary card-header inner-sportbook"
              >
                <span
                  _ngcontent-ng-c2501606979=""
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="true"
                  aria-controls="multiCollapseExample1"
                  className="minmax"
                  data-bs-target="#multiCollapseExample9501903112742"
                >
                  <strong _ngcontent-ng-c2501606979="">CARD</strong>
                </span>
                <div _ngcontent-ng-c2501606979="" className="minMaxDesktop">
                  <span _ngcontent-ng-c2501606979="">
                    Min/Max: 100 - 500000{" "}
                  </span>
                </div>
                <span _ngcontent-ng-c2501606979="" className="minMaxMobile">
                  <i
                    _ngcontent-ng-c2501606979=""
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    className="fa fa-info-circle ml-2"
                    data-bs-target="#multiCollapseExample9501903112742"
                    id="#collapse129501903112742"
                  />
                  <ul
                    _ngcontent-ng-c2501606979=""
                    className="dropdown-menu icon-range min-max-info text-end tooltip-betlimit"
                    aria-labelledby="collapse129501903112742"
                  >
                    <span _ngcontent-ng-c2501606979="">
                      Min/Max: 100 - 500000{" "}
                    </span>
                  </ul>
                </span>
              </span>
              <div _ngcontent-ng-c2501606979="" className="col">
                <div
                  _ngcontent-ng-c2501606979=""
                  className="collapse multi-collapse show"
                  id="multiCollapseExample9501903112742"
                >
                  <div
                    _ngcontent-ng-c2501606979=""
                    className="tbl-bets p-rltv sportbook-market-tbl"
                  >
                    <div
                      _ngcontent-ng-c2501606979=""
                      className="text-center cardMarket"
                    >
                      {" "}
                      {odds?.status == "SUSPEND" && (
                        <div
                          _ngcontent-ng-c2501606979=""
                          class="suspended-casino"
                        >
                          <span _ngcontent-ng-c2501606979="" class="stats-text">
                            Suspended
                          </span>
                        </div>
                      )}
                      {odds?.markets
                        ?.find((market) => market?.marketName === "CARD")
                        ?.oddDetailsDTO?.map((market, index) => (
                          <div _ngcontent-ng-c2501606979="">
                            <div
                              _ngcontent-ng-c2501606979=""
                              className="me-2 dt-card d-inline-block"
                              onClick={() =>
                                placeBet(
                                  `${
                                    odds?.markets?.find(
                                      (market) => market?.marketName === "CARD"
                                    )?.marketId
                                  }_${market?.selectionId}`,
                                  market?.runnerName,
                                  market?.back1
                                )
                              }
                            >
                              <div _ngcontent-ng-c2501606979="">
                                <img
                                  _ngcontent-ng-c2501606979=""
                                  src={`https://casino.queenexch.com/assets/lucky7_cards/${market?.runnerName}.png`}
                                />
                                {getUniversalCasinoPlExposureByRunner(
                                  exposure,
                                  market?.runnerName,
                                  market?.selectionId
                                )}
                              </div>
                              <div
                                _ngcontent-ng-c2501606979=""
                                className="ubook text-center m-t-5 text-success h-18"
                                style={{ marginLeft: 4 }}
                              ></div>
                            </div>
                          </div>
                        ))}
                    </div>
                    {odds?.markets
                      ?.find((market) => market?.marketName === "CARD")
                      ?.oddDetailsDTO?.map(
                        (market, index) =>
                          placeBetPayload?.marketIdWithSelectionId ==
                            `${
                              odds?.markets?.find(
                                (market) => market?.marketName === "CARD"
                              )?.marketId
                            }_${market?.selectionId}` && (
                            <PlaceBetUniversal
                              placeBetPayload={placeBetPayload}
                              setPlaceBetPayload={setPlaceBetPayload}
                              placeBet={placeBetCallApi}
                            />
                          )
                      )}
                  </div>
                </div>
              </div>
            </div>

            <GetUniversalLastTenResult lastResult={lastResult} />
          </div>
        </div>
      </app-teenpatti>
    </div>
  );
}
